import $ from "jquery";
import _ from "underscore";
import jsfix from "jsfix";
import { import_by_name } from "imports";

var __fix_f__ = [
  function ($root) {
    // Make it idempotent
    if ($root.data("has-base-fixes")) {
      return;
    }
    $root.data("has-base-fixes", true);

    // Ajax tables
    var fixAjaxTables = function () {
      if ($root.find(".listing").length) {
        import("jquery.tablesorter").then(function () {
          $root
            .find(".listing")
            .tablesorter({ sortlist: [0], widgets: ["zebra"] });
        });
      }
      if ($root.find(".ajax_list").length) {
        import("ajax_tables").then(function () {
          $root.find("div.ajax_list").asAjaxTable();
        });
      }
    };

    var fixCurrentLink = function () {
      var currentUrl = window.location.pathname;
      $("a").each(function () {
        if ($(this).attr("href") == currentUrl) {
          $(this).addClass("active");
        }
      });
    };

    fixCurrentLink();

    if ($root.find(".listing,.ajax_list").length) fixAjaxTables();

    if ($root.find("form").length)
      import_by_name("forms").then(function (forms) {
        forms.fix($root);
      });

    $root.find("[onenter]").each(function () {
      var t = $(this);
      f = t.attr("onenter");
      t.attr("onenter", "");
      t.keypress(function (ev) {
        if (ev.which == 10 || ev.which == 13) {
          eval(f);
        }
      });
    });
  },
  function ($root) {
    /// Load all required at require tags.
    $root.find("require").each(function () {
      var required = _($(this).text().split(","))
        .map(function (x) {
          return x.replace(/^\s+|\s+$/g, ""); // trim
        })
        .map(function (x) {
          import_by_name(x).then(function () {});
        });
    });
    $root.find("css").each(function () {
      var required = $(this).text().split(",");
      import_by_name("utils").then(function (utils) {
        utils.requireCSS(required);
      });
    });
  },
];

/**
 * @short Do fixes on loaded snippets. Use as require('coronis').fix($myjqueryelarray)
 *
 * @param $root is a jquery element array of new elements.
 */
var fix = function ($root) {
  if (!$root) $root = $("body");
  $(__fix_f__).each(function () {
    this($root);
  });
};

/**
 * @short Function that will be called when its necesary to do a fix.
 *
 * For example gstep needs to fix combo3.
 *
 * It passes the fixes as added, this way new fixes are automatically applied, order not important.
 *
 * @param f Fix function to call on every AJAX loaded snippet. Must be idempotent, applying f several times has the same effect as once.
 */
export var fix_register = function (f) {
  __fix_f__.push(f);
  f($("body"));
};

/**
 * @short jQuery find based on an element, but allow to search on parents too.
 *
 * To search on parent, start it with ::parent.
 */
var find = function ($el, sel) {
  if (!sel) return $([]);
  var sfind_rel = function ($el, sel) {
    if (!sel) return $el;
    if (sel.slice(0, 8) == "::parent") {
      return sfind_rel($el.parent(), $.trim(sel.slice(8)));
    }
    return $el.find(sel);
  };
  var sfind = function ($el, sel) {
    if (sel.slice(0, 8) == "::parent") {
      return sfind_rel($el, sel);
    }
    if (sel.slice(0, 2) == "..") {
      var end = sel.indexOf("..", 1);
      var csel = sel.slice(2, end);
      sel = sel.slice(end + 2);
      return sfind_rel($el.closest(csel), sel);
    }
    return $(sel);
  };

  if (sel.indexOf(",") >= 0) {
    var ret = [];
    $(sel.split(",")).map(function (i, ssel) {
      $.merge(ret, sfind($el, $.trim(ssel)));
    });
    return $(ret);
  }
  return sfind($el, sel);
};

var nid_seq = 1;
var ensureId = function ($el) {
  if ($el.attr("id")) return;
  var nid = "crns-" + nid_seq;
  nid_seq += 1;
  $el.attr("id", nid);
};

/**
 * @name js-submit-on-change
 * @short do an automatic post of this form when this element changes
 */
jsfix.register("js-submit-on-change", function ($el, data) {
  var post; // Depends on data
  if (data) {
    post = function () {
      $(data).submit();
    };
  } else {
    post = function () {
      $($el[0].form).submit();
    };
  }
  $el.change(post);
});

fix_register(jsfix.fix);

/**
 * @short For the given node and childs, replace id substrings.
 */
var replaceIds = function (node, oldid, newid) {
  for (var n in node.childNodes) {
    var nd = node.childNodes[n];
    var id = typeof nd.id;
    var name = typeof nd.name;
    if (id != "undefined" || name != "undefined") {
      replaceIds(nd, oldid, newid);
    }
  }
  if (node.id) node.id = node.id.replace(oldid, newid);
  if (node.name) node.name = node.name.replace(oldid, newid);
};

fix();

var coronis = {
  fix: fix,
  fix_register: fix_register,
  find: find,
  ensureId: ensureId,
  replaceIds: replaceIds,
};

export default coronis;
